module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TpQ8F6/tc-custom/9781460338759.jpg?1708748468964",
      "alt": "This image is the cover for the book Not Just a Cowboy, Texas Rescue"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Not Just a Cowboy, Texas Rescue\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A HURRICANE BROUGHT THEM TOGETHER "), _c('br'), _c('br'), _vm._v("Heiress Patricia Cargill was out to prove she was more than just a big bank account. Running Texas Rescue and Relief gives her the greatest satisfaction she could imagine. Until she meets volunteer Luke Waterson. He's a little younger, a little brasher and a lot more dangerous than anyone she's dated. He could be everything she needs. "), _c('br'), _c('br'), _vm._v("A STORM OF EMOTIONS COULD TEAR THEM APART "), _c('br'), _c('br'), _vm._v("An unexpected change of fortune, however, reveals Luke is more than just a nomadic cowboy. Falling for a millionaire rancher, especially one who keeps secrets, was not in her plans. But committing to a man who sees her as a desirable woman, not dollar signs, could be worth making an exception to this rule.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Caro Carson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Despite a no-nonsense background as a West Point graduate, Army officer, and Fortune 100 sales executive, Caro Carson has always treasured the happily-ever-after of a good romance novel. As a Rita-winning Harlequin author, Caro is delighted to be living her own happily-ever-after with her husband and children in Florida, a location which has saved the coaster-loving theme park fanatic a fortune on plane tickets.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0